import { ATTR_NAMES_LEAD } from '~/src/models/constants/attr-names-lead.constants';
import { TypeFilesEnum } from '~/src/models/enums/type-files.enum';
import { validateEmail } from '~/src/helpers/inputs-validators';
import type {
    MappedDataLeadAllReferralInterface,
    MappedDataLeadInterface,
    MappedDataLeadNotAuthInterface,
    MappedDataLeadReferralInterface,
    MappedDataOverloadInterface,
} from '~/src/layouts/clients-request-layout/clients-request-layout.types';
import {
    CreateLeadInterface,
    CreateLeadNotAuthInterface,
    CreateLeadReferralInterface,
} from '~/src/repositories/lead/types/lead.types';
import { ProductsDictionaryMappedInterface } from '~/src/repositories/cms/types/cms.types';

export const determineProductAvailability = (dataProducts: { [key: string]: ProductsDictionaryMappedInterface[] }, productCode: string) => {
    const dataProductWithoutCategories = [];
    for (const [_, value] of Object.entries(dataProducts)) {
        value && dataProductWithoutCategories.push(...value);
    }
    return dataProductWithoutCategories.some((product) => product.code === productCode);
};
export const getDataProducts = (formData: FormData) => {
    const { mtsProductCodes: mtsProductCodesKey } = ATTR_NAMES_LEAD;
    const formDataFromEntries = Object.fromEntries(formData);
    const formDataEntries = Object.entries(formDataFromEntries);
    const formDataEntriesFiltered = formDataEntries.filter(([key]) => key.includes(mtsProductCodesKey));
    const formDataProductsObject = Object.fromEntries(formDataEntriesFiltered);
    const formDataProductsObjectPure = Object.entries(formDataProductsObject).map(([key, value]) => {
        return [key.replace(mtsProductCodesKey, ''), value];
    });

    return formDataProductsObjectPure.map(([item]) => item) as string[];
};

// TODO необходим рефакторинг, тяжело уже добавлять новые данные в эту функцию
// @ts-ignore
export function getMappingData(props: MappedDataLeadReferralInterface): CreateLeadReferralInterface;
export function getMappingData(props: MappedDataLeadAllReferralInterface): CreateLeadReferralInterface;
export function getMappingData(props: MappedDataLeadNotAuthInterface): CreateLeadNotAuthInterface;
export function getMappingData(props: MappedDataLeadInterface): CreateLeadInterface;
export function getMappingData(props: MappedDataOverloadInterface) {
    const {
        formData,
        getFilesData,
        regionsData,
        agentPartyId,
        opf,
        mtsProductCodesOutOfForm,
        innOutOfForm,
        ogrnOutOfForm,
        referralCode,
        partnerPhoneNumber,
        partnerEmail,
        partnerOfficeNumber,
        isNotAuthCreateLead,
        promoIds,
        clientType,
    } = props;

    const formDataFromEntries = Object.fromEntries(formData);
    const firstElem = 0;

    const {
        contactFio,
        phoneNumber,
        legalName,
        inn,
        ogrn,
        serviceProvisionAddress,
        comment,
        email,
        agentWorkEmail,
    } = formDataFromEntries;

    const [regionData] = regionsData.filter((elem) => elem.name === formDataFromEntries['regionId']);

    const getPhone = (phone: string) => {
        return String(phone).replace(/[ ()]/g, '').replaceAll('-', '').replaceAll(' ', '').replace('+7', '');
    };

    const checkUndefinedString = (value: string | null) => {
        if (value === 'undefined') {
            return '';
        }

        return String(value || '');
    };

    const getLegalName = () => {
        if (legalName && opf?.shortName) {
            return opf?.shortName + ' ' + String(legalName);
        }
        return String(legalName);
    };

    const getEmail = (email: string) => {
        if (validateEmail(email)) {
            return email;
        }
        return '';
    };

    const getIdProp = () => {
        if (agentPartyId) {
            return { agentPartyId, referralCode: '' };
        }

        if (referralCode) {
            return { referralCode, agentPartyId: '' };
        }
        return { referralCode: '', agentPartyId: '' };
    };

    const emailForReturnedData = getEmail(checkUndefinedString(String(email)));

    const requestBody = {
        contactFio: checkUndefinedString(String(contactFio)),
        legalName: checkUndefinedString(getLegalName()),
        inn: innOutOfForm || checkUndefinedString(String(inn)),
        ogrn: ogrnOutOfForm || checkUndefinedString(String(ogrn)),
        comment: checkUndefinedString(String(comment)),
        serviceProvisionAddress: checkUndefinedString(String(serviceProvisionAddress)),
        regionId: regionData.id,
        mtsProductCodes: mtsProductCodesOutOfForm?.length ? mtsProductCodesOutOfForm : getDataProducts(formData),
        file: getFilesData ? getFilesData(TypeFilesEnum.additionLead)[firstElem] : undefined,
        ...(clientType ? { clientType: clientType } : {}),
        ...(promoIds?.length ? { promoIds: promoIds } : {}),
        ...getIdProp(),
    };

    if (isNotAuthCreateLead) {
        return {
            partnerPhoneNumber: partnerPhoneNumber ? getPhone(partnerPhoneNumber) : undefined,
            partnerEmail: partnerEmail || getEmail(String(agentWorkEmail)) || undefined,
            partnerOfficeNumber: partnerOfficeNumber || undefined,
            contactPhoneNumber: getPhone(String(phoneNumber)),
            ...requestBody,
            ...(emailForReturnedData ? { contactEmail: emailForReturnedData } : {}),
        };
    }

    return {
        phoneNumber: getPhone(String(phoneNumber)),
        ...requestBody,
        ...(emailForReturnedData ? { email: emailForReturnedData } : {}),
    };
}
